import API from "./API";

export default class Exportation extends API
{
    static async export_file(params) {
        return this.post("api/admin/export", params);
    }

    static async deleteExportation(id) {
        return this.delete("api/admin/export/file/" + id)
    }

    static async getExports() {
        return this.get("api/admin/export/queue");
    }

    static async getWorksersCategories() {
        return this.get("api/admin/export/workers-categories");
    }
}